export class CourseSearchForm {
  constructor(
    public isWeekendsOnly: boolean = false,
    public hasCourseFee: boolean = false,
    public trainingProgramId: string = '00000000-0000-0000-0000-000000000000',
    public trainingProviderRegistrationId: string | undefined = undefined,
    public trainingProviderName: string = '',
    public instructorName: string = '',
    public scheduleStatus: string = '',
    public classStatus: string = '',
    public language: string = '',
    public trainingTypeIdCommaSeparated: string = '00000000-0000-0000-0000-000000000000',
    public cityTown: string = '',
    public fromDate?: Date,
    public toDate?: Date,
    public minSeatsAvailable: number = 0,
    public sortingOption: string = 'Earliest-Latest',
    public pageIndex: number = 0,
    public pageSize: number = 10,
    public captchaToken: string = '') { }
}

export class TrainingType {
  constructor(
    public TrainingTypeId: string,
    public Name: string,
    public NameFr: string) { }
}
